import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { usePriceAgreement } from '@components/Agreements/api/usePriceAgreements';
import { InheritedBusinessUnitField } from './inherited-business-unit-field';

interface FormValues {
  businessUnitId: number | null;
  priceAgreementId: number | null;
}

export const PriceUpdateBusinessUnitField = () => {
  const { control, getValues, setValue } = useFormContext<FormValues>();
  const priceAgreementId = useWatch({ control, name: 'priceAgreementId' });
  const { data: agreement } = usePriceAgreement(priceAgreementId);
  const businessUnitId = agreement?.business_unit_id != null ? Number(agreement.business_unit_id) : null;

  useEffect(() => {
    if (getValues('businessUnitId') !== businessUnitId) setValue('businessUnitId', businessUnitId);
  }, [businessUnitId, getValues, setValue]);

  return <InheritedBusinessUnitField priceAgreementId={priceAgreementId} />;
};
